// Logo SVG — Pizzeria da Sofia
// Sigillo tipografico minimal e lineare: doppio anello oro,
// monogramma "S" in italic serif, scritta "PIZZERIA" arcuata + "DA SOFIA" lineare.

export const LogoMark = ({ size = 48, className = "" }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Pizzeria da Sofia logo"
  >
    <defs>
      <path id="topArcLogo" d="M 18,50 A 32,32 0 0 1 82,50" fill="none" />
    </defs>
    {/* doppi anelli oro */}
    <circle cx="50" cy="50" r="48" fill="none" stroke="#B8924A" strokeWidth="0.6" />
    <circle cx="50" cy="50" r="44.5" fill="none" stroke="#B8924A" strokeWidth="0.35" />

    {/* PIZZERIA arcuato */}
    <text fontSize="7" letterSpacing="3.5" fill="#2A1F18" fontWeight="500" fontFamily="'Manrope', sans-serif">
      <textPath href="#topArcLogo" startOffset="50%" textAnchor="middle">PIZZERIA</textPath>
    </text>

    {/* monogramma S italic */}
    <text
      x="50"
      y="60"
      fontSize="40"
      fill="#2A1F18"
      fontStyle="italic"
      textAnchor="middle"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontWeight="500"
    >
      S
    </text>

    {/* divisore + scritta inferiore */}
    <line x1="36" y1="71" x2="64" y2="71" stroke="#B8924A" strokeWidth="0.45" />
    <text
      x="50"
      y="80"
      fontSize="6"
      letterSpacing="3"
      fill="#8C6E33"
      textAnchor="middle"
      fontWeight="600"
      fontFamily="'Manrope', sans-serif"
    >
      DA SOFIA
    </text>
    <circle cx="50" cy="86" r="0.9" fill="#B8924A" />
  </svg>
);

// versione pulita — solo monogramma SD intrecciato per favicon o usi compatti
export const LogoMonogram = ({ size = 32, className = "" }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Pizzeria da Sofia"
  >
    <text
      x="50"
      y="68"
      fontSize="62"
      fill="currentColor"
      fontStyle="italic"
      textAnchor="middle"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontWeight="500"
    >
      S
    </text>
  </svg>
);
